import styled from 'styled-components';

export const StyledPrescriptionListHeader = styled.div`
   z-index: 1;
   position: sticky;
   top: 0;
   background-color: ${({ theme }) => theme.backgroundBody};
   display: grid;
   grid-template-columns: 262px 1fr;
   grid-template-rows: auto auto;
   align-items: center;
   padding-bottom: 4px;
   grid-gap: 0 8px;

   &:has(:nth-child(2)) {
      grid-gap: 8px;
   }

   &:not(:first-child) {
      margin-top: 12px;
   }
`;

StyledPrescriptionListHeader.displayName = 'StyledPrescriptionListHeader';
